import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Shell({ children }) {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined") window.scrollTo({ top: 0 });
  }, [location.pathname]);

  return (
    <div style={{ maxWidth: 420, margin: "0 auto", fontFamily: "'DM Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500&family=Fraunces:opsz,wght@9..144,500;9..144,600&display=swap" rel="stylesheet" />
      {/* Desktop hub redesign fonts (Inter + JetBrains Mono). Loaded
          globally but only consumed by the desktop-only hub components and
          the ≥1024px CSS uplift in responsive.css — mobile keeps DM Sans /
          Fraunces. See src/shared/components/desktop/. */}
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=JetBrains+Mono:wght@450;500;600;700&display=swap" rel="stylesheet" />
      <div style={{
        background: "#fff", borderRadius: 20, border: "1px solid #e8e8e8",
        overflow: "hidden", minHeight: 640, maxHeight: 720,
        display: "flex", flexDirection: "column", position: "relative",
      }}>{children}</div>
    </div>
  );
}
